import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import { MODULE, SECURABLE, PageProps } from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import { observer } from "mobx-react";
import Grid from "core/grid/domain/grid";
import { loc } from "core/common/config/locales";
import GridComp, { BULKACTIONTYPE } from "core/grid/component/gridComp";
import ConfirmationDialog from 'core/components/confirmationDialog/confirmationDialog';
import { action } from "mobx";
import commonService from 'core/common/service/commonService';
import { IDomainObject } from 'core/form/formUtils';
import BrimMessageExpando from 'core/dataimport/component/brimMessageExpando';
import dataImportService from '../dataImportService';

const gridLocation = 'brimMessageList';
@observer
export default class ParamKeyList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.product;
  static title = loc.i18n`Brim Message`;
  static icon = 'key';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("BrimMessage#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }


  private _confirmation: ConfirmationDialog;


  accept = (grid: Grid) => {
    this._confirmation.open(success => {
        commonService.loading(true);
        dataImportService.acceptBrimMessage(grid.createFullParams())
        .then(action("accepting-brimMessage", (domainObject: IDomainObject) => {
          commonService.loading(false);
        grid.search(domainObject);
        }));
      }, cancel => {
      }, 'Do you want to Accept all ' + grid.getSelectedCount() + ' changes?');
    };

  reject = (grid: Grid) => {
    this._confirmation.open(success => {
        commonService.loading(true);
        dataImportService.rejectBrimMessgage(grid.createFullParams())
        .then(action("rejecting-brimMessage", (domainObject: IDomainObject) => {
          commonService.loading(false);
        grid.search(domainObject);
        }));
      }, cancel => {
      }, 'Do you want to Reject all ' + grid.getSelectedCount() + ' changes?');
    };

  validate = (grid: Grid) => {
    this._confirmation.open(success => {
      commonService.loading(true);
      dataImportService.validateBrimMessage(grid.createFullParams())
      .then(action("validating-brimMessage", (domainObject: IDomainObject) => {
        commonService.loading(false);
        grid.search(domainObject);
      }));
    }, cancel => {
    }, 'Do you want to Validate all ' + grid.getSelectedCount() + ' changes?');

  };

  ConfirmationDialogRef = comp => { this._confirmation = comp; };


  render() {
    let { params, query } = this.props;

    let bulkActions = [
      { type: BULKACTIONTYPE.ACTION as BULKACTIONTYPE, label: 'Accept', fn: this.accept, that: this, securable: SECURABLE.brimMessageAction },
      { type: BULKACTIONTYPE.ACTION as BULKACTIONTYPE, label: 'Reject', fn: this.reject, that: this, securable: SECURABLE.brimMessageAction },
      { type: BULKACTIONTYPE.ACTION as BULKACTIONTYPE, label: 'Validate', fn: this.validate, that: this, securable: SECURABLE.brimMessageAction },
    ];

    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)}
        entities={mdEntityService.entityMap}
        gridId={params.gridId} query={query} bulkActions={bulkActions} showExpand ExpandComponent={BrimMessageExpando} >
        <ConfirmationDialog ref={this.ConfirmationDialogRef} />
      </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/core/dataimport/page/brimMessagesList.tsx